var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn aanmeldbutton-home",on:{"click":_vm.gotoLogin}},[_vm._v(_vm._s(_vm.$t('event.Inschrijven'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }